export interface QuickBooksExportablePurchaseOrderConstructor {
  procurifyPoNumber: number // procurify_PO — selection key for stage/archive/unstage
  poNumber: string // PO_Num; may be empty
  date: Date
  purchaserName: string
  vendorName: string
  total: string
  purchasedCurrency: Nullable<string> // currency name; unconfirmed live (see HLD Open Questions)
  uuid: string // detail link /#/purchase/order/details/{uuid}
  stagedForExport: boolean
}

export class QuickBooksExportablePurchaseOrder {
  readonly procurifyPoNumber: number
  readonly poNumber: string
  readonly date: Date
  readonly purchaserName: string
  readonly vendorName: string
  readonly total: string
  readonly purchasedCurrency: Nullable<string>
  readonly uuid: string
  readonly stagedForExport: boolean

  constructor(data: QuickBooksExportablePurchaseOrderConstructor) {
    this.procurifyPoNumber = data.procurifyPoNumber
    this.poNumber = data.poNumber
    this.date = data.date
    this.purchaserName = data.purchaserName
    this.vendorName = data.vendorName
    this.total = data.total
    this.purchasedCurrency = data.purchasedCurrency
    this.uuid = data.uuid
    this.stagedForExport = data.stagedForExport
  }

  // Exportable/Exported PO label: PO_Num when present, else "PF{procurify_PO}"
  // (BHV-034).
  get displayLabel(): string {
    return this.poNumber || `PF${this.procurifyPoNumber}`
  }

  // Archived rows render the bare procurify_PO, no PF prefix (BHV-034).
  get archivedDisplayLabel(): string {
    return String(this.procurifyPoNumber)
  }

  // "1200 USD" when a currency is present, bare total otherwise (BHV-044).
  get displayTotal(): string {
    return this.purchasedCurrency
      ? `${this.total} ${this.purchasedCurrency}`
      : this.total
  }
}
